import React, { useState } from 'react';
import { FaPlus, FaCheck, FaTimes } from 'react-icons/fa';
import { useWatchlist } from '../context/WatchlistContext';
import './WatchlistModal.css';

const WatchlistModal = ({ stock, onClose, position }) => {
  const { 
    watchlists, 
    addToWatchlist, 
    removeFromWatchlist, 
    createWatchlist,
    isInSpecificWatchlist 
  } = useWatchlist();
  
  const [showCreateNew, setShowCreateNew] = useState(false);
  const [newWatchlistName, setNewWatchlistName] = useState('');

  const handleAddToWatchlist = (watchlistId) => {
    if (isInSpecificWatchlist(stock.symbol, watchlistId)) {
      removeFromWatchlist(stock.symbol, watchlistId);
    } else {
      addToWatchlist(stock, watchlistId);
    }
  };

  const handleCreateNew = () => {
    if (newWatchlistName.trim()) {
      const newId = createWatchlist(newWatchlistName.trim());
      addToWatchlist(stock, newId);
      setNewWatchlistName('');
      setShowCreateNew(false);
      onClose();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleCreateNew();
    } else if (e.key === 'Escape') {
      setShowCreateNew(false);
      setNewWatchlistName('');
    }
  };

  return (
    <>
      <div className="watchlist-modal-overlay" onClick={onClose} />
      <div 
        className="watchlist-modal" 
        style={{ 
          top: position.top, 
          left: position.left 
        }}
      >
        <div className="watchlist-modal-header">
          <h3>Add to Watchlist</h3>
          <button className="close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        
        <div className="watchlist-modal-content">
          {!showCreateNew ? (
            <>
              <button 
                className="create-new-btn"
                onClick={() => setShowCreateNew(true)}
              >
                <FaPlus /> Create New Watchlist
              </button>
              
              <div className="watchlist-divider">
                <span>or add to existing</span>
              </div>
              
              <div className="watchlist-list">
                {watchlists.map(wl => {
                  const isInList = isInSpecificWatchlist(stock.symbol, wl.id);
                  return (
                    <button
                      key={wl.id}
                      className={`watchlist-item ${isInList ? 'active' : ''}`}
                      onClick={() => handleAddToWatchlist(wl.id)}
                    >
                      <span className="watchlist-name">{wl.name}</span>
                      <span className="watchlist-count">
                        {wl.stocks.length} stocks
                      </span>
                      {isInList && <FaCheck className="check-icon" />}
                    </button>
                  );
                })}
              </div>
            </>
          ) : (
            <div className="create-watchlist-form">
              <input
                type="text"
                placeholder="Enter watchlist name"
                value={newWatchlistName}
                onChange={(e) => setNewWatchlistName(e.target.value)}
                onKeyDown={handleKeyPress}
                autoFocus
                className="watchlist-input"
              />
              <div className="form-actions">
                <button 
                  className="btn-cancel"
                  onClick={() => {
                    setShowCreateNew(false);
                    setNewWatchlistName('');
                  }}
                >
                  Cancel
                </button>
                <button 
                  className="btn-create"
                  onClick={handleCreateNew}
                  disabled={!newWatchlistName.trim()}
                >
                  Create & Add
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default WatchlistModal;
